import { render, staticRenderFns } from "./CreateNewRole.vue?vue&type=template&id=654a7ee2&scoped=true"
import script from "./CreateNewRole.vue?vue&type=script&lang=js"
export * from "./CreateNewRole.vue?vue&type=script&lang=js"
import style0 from "./CreateNewRole.vue?vue&type=style&index=0&id=654a7ee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a7ee2",
  null
  
)

export default component.exports